"use strict"

import axios from "axios";

const state = function() {
  return {
    tagsLoading: false,
    tagsLoaded: false,
    tagsGroups: [],
    tags: []
  };
};

const getters = {
  getGroupedTags: (state, rootGetters) => {
    return state.tagsGroups.map(x => {
      const tags = state.tags.filter(i => {
        if(i.group.id === x.id) {
          return i.name
        } else {
          return false
        }
      });

      if (tags.length > 0) {
        return {
          groupId: x.id,
          groupName: x.name,
          tags: tags
        }
      } else {
        return {
          groupId: '',
          groupName: '',
          tags: []
        }
      }
    })
  }
};

const mutations = {
  SET_GROUPS_TAGS: (state, payload) => {
    state.tagsGroups = payload;
  },

  SET_TAGS: (state, payload) => {
    state.tags = payload;
  },

  SET_TAGS_LOADED: (state, payload) => {
    state.tagsLoaded = payload;
  },

  SET_TAGS_LOADING: (state, payload) => {
    state.tagsLoading = payload;
  }
};

const actions = {
  async fetchTagsGroups({ commit }) {
    await axios.get(`/1.0/response/tag-groups`)
      .then(x => {
        commit("SET_GROUPS_TAGS", x.data.data);
      })
  },

  async fetchTags({ commit, dispatch }, tags) {
    commit('SET_TAGS_LOADING', true);

    await dispatch('fetchTagsGroups');

    const candidateTagsIds = tags.map(x => x.id);

    await axios.get(`/1.0/response/tags`)
      .then(x => {
        // Фильтруем только те теги которые есть у пользователя
        const tags = x.data.data
          .filter(y => {
            if (candidateTagsIds.includes(y.id)) {
              return true;
            }
          })

        commit("SET_TAGS", tags);
        commit('SET_TAGS_LOADED', true);
      })
      .finally(() => {
        commit('SET_TAGS_LOADED', true);
        commit('SET_TAGS_LOADING', false);
      })
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
